const defaultString = ''

const ALLOWED_DOMAIN_NAMES = ['mckinsey.id', 'id.mckinsey.com.cn']

const autodiscoverAccountLifecycleDomain = () => {
  /**
   * @NOTE
   * Uses `URL.hostname` instead of `URL.host`
   * `hostname` strips the port number component
   * `host` contains the port number component (host = `${hostname}:${port}`)
   */
  const { hostname, protocol } = globalThis.location
  if (protocol !== 'https:' || ALLOWED_DOMAIN_NAMES.every((domain) => !hostname.endsWith(domain))) {
    const error = Error('Only McKinseyID domains are authorized as base URL. Ensure this page belongs to McKinseyID')
    error.name = 'UnauthorizedBaseUrl'
    if (hostname === 'localhost') {
      error.message +=
        '. If you are using this in a local environment (localhost), try setting OVERRIDE_ACCOUNT_LIFECYCLE_BASE_URL to override the autodiscovery'
    }
    throw error
  }
  const [, ...host] = hostname.split('.')
  return [`${protocol}//account`, ...host].join('.')
}

export const getAccountLifecycleDomain = () => {
  /** @NOTE use `OVERRIDE_ACCOUNT_LIFECYCLE_BASE_URL` environment variable for local environment */
  if (globalThis.overrideAccountLifecycleBaseUrl) return global.overrideAccountLifecycleBaseUrl
  return autodiscoverAccountLifecycleDomain()
}

export const getForgotPasswordAbsoluteLink = ({ login = defaultString, clientId = defaultString }) => {
  try {
    const url = new URL(getAccountLifecycleDomain())
    url.pathname = globalThis.accountLifecycleBasePath ?? '/'
    const forgotPasswordPage = '/forgot-password'
    url.pathname += url.pathname.endsWith('/') ? forgotPasswordPage.substring(1) : forgotPasswordPage

    if (login && typeof login === 'string') {
      url.searchParams.set('login', login)
    }
    if (clientId && typeof clientId === 'string') {
      url.searchParams.set('client_id', clientId)
    }
    return url.toString()
  } catch (e) {
    // Avoid run-time errors for the screen to go blank
    console.error(e)
    return defaultString
  }
}
